module.exports = __webpack_public_path__ + "static/media/frame-lose.27b8e981.png";